import { Sheet, SheetContent, SheetHeader, SheetTrigger } from '@/components/ui/sheet';
import { useState } from 'react';
import { useTheme } from '@/components/ThemeProvider';
import TradeConfigController from './components/TradeConfigController';
import { useTradeStore } from '../../store';
import { useAppStore } from '@/store';

export default () => {
  const { chainInfo } = useAppStore();
  const { bscTradeSetting, solTradeSetting } = useTradeStore();
  const [open, setOpen] = useState(false);
  const { theme } = useTheme();
  const { slippage, slippageAuto, fee, feeAuto, antiMevOpen } = chainInfo.chainId == 56 ? bscTradeSetting : solTradeSetting;
  const symbol = chainInfo.chain == 'solana' ? chainInfo.symbol : 'Gwei';
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <div className="flex gap-x-[9px] text-[14px]">
          <div className="flex items-center">
            <img src={theme == 'light' ? '/icon/slippage-dark.svg' : '/icon/slippage-light.svg'} className="w-[20px] h-[20px]" />
            <span>{slippageAuto ? 'Auto' : slippage + '%'}</span>
          </div>
          <div className="flex items-center">
            <img src={theme == 'light' ? '/icon/priorityFee-dark.svg' : '/icon/priorityFee-light.svg'} className="w-[20px] h-[20px]" />
            <span>{feeAuto ? 'Auto' : fee + symbol}</span>
          </div>
          <div className="flex items-center">
            <img src={antiMevOpen ? '/icon/safe.png' : '/icon/no-safe.png'} className="w-[20px] h-[20px]" />
            <span>MEV</span>
          </div>
        </div>
      </SheetTrigger>
      <SheetContent
        side="bottom"
        hideCloseIcon
        className="w-full overflow-y-auto p-[16px] pb-[40px] h-[500px] border-t-[1px] border-t-borderColor gap-y-[40px]"
        onOpenAutoFocus={(e) => e.preventDefault()}
      >
        <SheetHeader hidden />
        <TradeConfigController setOpen={setOpen} />
      </SheetContent>
    </Sheet>
  );
};
